import React from 'react';
import { useConfigService } from '@thd-nucleus/experience-context';
import { Badge } from './Badge';
import { LEARN_MORE_LINK } from '../../../utils/constants';
import { clickEvents } from '../../../utils/analytics';

export const VeteranBadge = ({ size, onShowTooltip }) => (
  <Badge
    badgeType="veteran"
    image="https://assets.thdstatic.com/images/v1/path-to-pro/badges/badge-military-icon.svg"
    name="Military Service Member"
    additionalContent="Individuals who are active duty, retired military, or reservist, self-identified."
    size={size}
    onShowTooltip={onShowTooltip}
  />
);

export const EducationBadge = ({ size, onShowTooltip }) => (
  <Badge
    badgeType="education"
    image="https://assets.thdstatic.com/images/v1/path-to-pro/badges/badge-education.svg"
    name="Two or more Years of Higher Education "
    additionalContent="Individuals who have earned an Associates degree, Bachelors, Masters or Doctoral degree, self-identified."
    size={size}
    onShowTooltip={onShowTooltip}
  />
);

export const AccreditedTrainingBadge = ({ size, onShowTooltip }) => (
  <Badge
    badgeType="accredited-training"
    image="https://assets.thdstatic.com/images/v1/path-to-pro/badges/badge-accredited-training.svg"
    name="Accredited Training Program"
    additionalContent="Individuals who have completed an accredited training program within the trades, Check the candidates profile for more details, self-identified."
    size={size}
    onShowTooltip={onShowTooltip}
  />
);

export const BehrTrainingBadge = ({ size, onShowTooltip }) => {
  const isBehrEnabled = useConfigService('fs:isBehrEnabled');

  return (isBehrEnabled && (
    <Badge
      badgeType="behr-training"
      image="https://assets.thdstatic.com/images/v1/path-to-pro/badges/badge-behr.svg"
      name="Behr Paint Curriculum"
      additionalContent="Completed Trades Essentials Paint course featuring step by step paint content."
      size={size}
      onShowTooltip={onShowTooltip}
    />
  ));
};

export const BootcampBadge = ({ size, onShowTooltip }) => (
  <Badge
    badgeType="bootcamp"
    image="https://assets.thdstatic.com/images/v1/path-to-pro/badges/badge-bootcamp-grad.svg"
    name="Path To Pro Skills Program"
    additionalContent={(
      <>
        <span>
        Skills Program graduates have completed training in basic skills such as communication,
        safety and tool basics to support entry into the trades.{' '}
        </span>
        <a
          className="link-blue"
          target="_blank"
          rel="noopener noreferrer"
          href={LEARN_MORE_LINK}
          onClick={() => clickEvents.candidateBadgeProfileInteraction('skills program>learn more')}
        >
      Learn More
        </a>
      </>
    )}
    size={size}
    onShowTooltip={onShowTooltip}
  />
);
